import { FC } from 'react';

import CopyLink from '../../CopyLink';
import ShareInServices from '../ShareInServices';

import ShareDialogWrapper, { Title } from './Wrapper';

export type ShareDialogProps = {
  shareLink: string;
  onClose: () => void;
  title?: string;
  isServices?: boolean;
  description?: string;
  onShare?(serviceName: string): void;
};

const ShareDialog: FC<ShareDialogProps> = ({
  title = 'Share',
  description,
  isServices = true,
  onClose,
  shareLink,
  onShare
}) => (
  <ShareDialogWrapper onModalClose={onClose}>
    <Title size="medium" color="black" {...{ title, description }} />
    <CopyLink link={shareLink} />
    {isServices && <ShareInServices url={shareLink} {...{ title, onShare }} />}
  </ShareDialogWrapper>
);

export default ShareDialog;
